import React from "react";
import { SingleDatePicker } from 'react-dates';
import './styles.scss'

const component = (props) =>
  <SingleDatePicker {...props} />

component.displayName = 'DatePicker';
export default component;

/* import React from "react";
import DayPicker from "react-day-picker";
import './styles.scss'

const component = props => 
  <SingleDatePicker {...props} />;

component.displayName = "DatePicker";
export default component; */


// WEBPACK FOOTER //
// ./client/components/DatePicker/index.js